module.exports = __webpack_public_path__ + "static/media/custom-ex-8.1bd22a0f.jpg";